import {Club} from '../resources/Club';
import {EntityExportAvailableEvent} from './EntityExportAvailableEvent';

/**
 * This event can be fired to indicate that some data as requested via the
 * {@see ClubsExportRequested} event is available and can be processed.
 */
export class ClubsExportAvailable extends EntityExportAvailableEvent<Club> {}
